import { CalendarCheck, Layers, FileSignature } from "lucide-react";

const ITEMS = [
  { icon: CalendarCheck, text: "Manage, reschedule or cancel your bookings" },
  { icon: Layers, text: "Access your programs, groups and packages" },
  { icon: FileSignature, text: "Keep your signed agreements on file — sign once" },
];

export default function AccountBenefits() {
  return (
    <ul className="space-y-1.5" data-testid="account-benefits">
      {ITEMS.map(({ icon: Icon, text }) => (
        <li key={text} className="flex items-start gap-2 text-xs text-[#4A5D6B]">
          <Icon size={14} className="text-[#5C8A72] mt-0.5 shrink-0" aria-hidden="true" /> {text}
        </li>
      ))}
    </ul>
  );
}
